import React from 'react';

export type BadgeTone = 'green' | 'red' | 'amber' | 'blue' | 'gray' | 'purple';

const TONES: Record<BadgeTone, { bg: string; text: string; dot: string }> = {
  green: { bg: '#f0fdf4', text: '#16a34a', dot: '#16a34a' },
  red: { bg: '#fef2f2', text: '#dc2626', dot: '#dc2626' },
  amber: { bg: '#fffbeb', text: '#d97706', dot: '#d97706' },
  blue: { bg: '#eff6ff', text: '#2563eb', dot: '#2563eb' },
  purple: { bg: '#f5f3ff', text: '#003c6c', dot: '#003c6c' },
  gray: { bg: '#f3f4f6', text: '#4b5563', dot: '#9ca3af' },
};

export default function Badge({
  children,
  tone = 'gray',
  dot = true,
}: {
  children: React.ReactNode;
  tone?: BadgeTone;
  dot?: boolean;
}) {
  const c = TONES[tone];
  return (
    <span
      className="inline-flex items-center gap-1.5 text-[11px] font-bold px-2.5 py-1 rounded-full whitespace-nowrap"
      style={{ background: c.bg, color: c.text }}
    >
      {dot && <span className="w-1.5 h-1.5 rounded-full" style={{ background: c.dot }} />}
      {children}
    </span>
  );
}

/** Maps common status strings to a sensible tone automatically. */
export function statusToTone(status: string): BadgeTone {
  const s = status.toLowerCase();
  if (['active', 'complete', 'completed', 'paid', 'resolved', 'verified', 'success'].includes(s)) return 'green';
  if (['pending', 'processing', 'in_progress', 'open'].includes(s)) return 'amber';
  if (['cancelled', 'canceled', 'failed', 'suspended', 'rejected', 'expired'].includes(s)) return 'red';
  if (['trial', 'free', 'draft'].includes(s)) return 'blue';
  return 'gray';
}
